/**
 * Client Supabase — singleton.
 * Variables d'env définies dans .env.local (voir .env.example).
 */

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// ---------- Helpers ----------

/**
 * Récupère la session courante (utilisateur connecté ou null).
 */
export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.error('[supabase] getSession error :', error);
    return null;
  }
  return data.session;
}

/**
 * Récupère l'utilisateur courant ou null.
 */
export async function getUser() {
  const session = await getSession();
  return session?.user ?? null;
}

/**
 * Test de connectivité — appelé depuis la page d'accueil pour confirmer que
 * la connexion Supabase fonctionne.
 */
export async function pingSupabase() {
  try {
    const { error } = await supabase.from('species').select('id').limit(1);
    if (error) throw error;
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err.message };
  }
}
